export default {"src":"/_next/static/media/logo.c55f10b7.svg","height":195,"width":243};